import { isRSAA, RSAA } from 'redux-api-middleware';
import { selectors } from '../config';
const CONST_404 = 404;
const stubMiddleware = store => next => action => {
  const storeState = store.getState();
  if (
    !isRSAA(action) ||
    process.env.NODE_ENV !== 'development' ||
    !selectors.stubsEnabled(storeState)
  ) {
    return next(action);
  }

  const token = selectors.accessToken(storeState);
  return next({
    ...action,
    [RSAA]: {
      ...action[RSAA],
      fetch: (...fetchArgs) =>
        fetch(
          `./stubs/${token}${new URL(action[RSAA].endpoint, window.location.origin).pathname}`
        ).then(resp => {
          if (resp.status === CONST_404) {
            // Keep console statement for development info
            // eslint-disable-next-line no-console
            console.warn('No mock for', action[RSAA].endpoint);
            return fetch(...fetchArgs);
          }
          return resp.json().then(
            json =>
              new Response(JSON.stringify(json), {
                status: 200,
                headers: {
                  'Content-Type': 'application/json'
                }
              })
          );
        })
    }
  });
};

export default stubMiddleware;
